export default {
	colors: {
		red1100: '#993944',
		red1000: '#800000',

		black1000: '#161616',
		black900: '#232323',
		black850: '#484848',
		black800: '#666666',
		black700: '#989898',
		black600: '#828282',
		black500: '#333333',

		white1000: '#FFFFFF',

		gray100: '#F4F4F4',
		gray200: '#EAEAEA',
		gray300: '#E5E5E5',
		gray400: '#D7D7D7',
		gray500: '#D5D5D5',
		gray600: '#F9F5EB',

		tiffanyBlue: '#0ABAB5',
		green1100: '#3D5A24',

		white06: 'rgba(255, 255, 255, 0.6)',
	},

	mediaQuery: {
		desktopSizeXL: '2560px',
		desktopSizeL: '1920px',
		desktopSizeM: '1536px',
		desktopSizeS: '1366px',
		tabletSize: '1280px',
		tabletSizeX: '1024px',
		tabletSizeS: '768px',

		desktopSizeXLMin: '2559px',
		desktopSizeLMin: '1919px',
		desktopSizeMMin: '1535px',
		desktopSizeSMin: '1365px',
		tabletSizeMin: '1279px',
		tabletSizeXMin: '1023px',
		tabletSizeSMin: '767px',
	},
	form: {
		colors: {
			//! Box Shadow
			boxShadowColor: '',

			//! Empty Text Color
			emptyTextColor: '#161616',

			//! Message colors
			successMessageColor: '#4CAF50',
			successMessageBorderColor: '#4CAF50',
			successMessageBgColor: 'rgba(76, 175, 80, 0.1)',
			errorMessageColor: '#BC161D',
			errorMessageBorderColor: '#BC161D',
			errorMessageBgColor: 'rgba(222, 85, 78, 0.1)',

			//! Label
			labelColor: '#161616',
			labelHoverColor: '',
			labelFocusColor: '',
			labelActiveColor: '',
			labelErrorColor: '#BC161D',
			labelDisabledColor: '#D5D5D5',

			//! Input
			inputColor: '#161616',
			inputHoverColor: '',
			inputFocusColor: '#161616',
			inputActiveColor: '',
			inputErrorColor: '#BC161D',
			inputDisabledColor: '#D5D5D5',

			inputPlaceholderColor: '#161616',
			inputPlaceholderHoverColor: '',
			inputPlaceholderFocusColor: '#161616',
			inputPlaceholderActiveColor: '',
			inputPlaceholderErrorColor: '#BC161D',
			inputPlaceholderDisabledColor: '',

			inputBorderColor: '#D5D5D5',
			inputBorderHoverColor: '',
			inputBorderFocusColor: '',
			inputBorderActiveColor: '',
			inputBorderErrorColor: '#BC161D',
			inputBorderDisabledColor: '#F5F6F5',

			inputBgColor: '#FFFFFF',
			inputHoverBgColor: '',
			inputFocusBgColor: '',
			inputActiveBgColor: '',
			inputErrorBgColor: 'rgb(250, 243, 240)',
			inputDisabledBgColor: '#F5F6F5',

			//! Select
			selectColor: '#232323',
			selectHoverColor: '',
			selectFocusColor: '#161616',
			selectActiveColor: '',
			selectErrorColor: '#BC161D',
			selectDisabledColor: '',

			selectPlaceholderColor: '#232323',
			selectPlaceholderHoverColor: '',
			selectPlaceholderFocusColor: '#161616',
			selectPlaceholderActiveColor: '',
			selectPlaceholderErrorColor: '#BC161D',
			selectPlaceholderDisabledColor: '',

			selectBorderColor: '#F4F4F4',
			selectBorderHoverColor: '#F4F4F4',
			selectBorderFocusColor: '#F4F4F4',
			selectBorderActiveColor: '',
			selectBorderErrorColor: '#BC161D',
			selectBorderDisabledColor: '#F5F6F5',

			selectBgColor: '#F4F4F4',
			selectHoverBgColor: '',
			selectFocusBgColor: '',
			selectActiveBgColor: '',
			selectErrorBgColor: 'rgb(250, 243, 240)',
			selectDisabledBgColor: '#F5F6F5',

			selectOptionColor: '#232323',
			selectOptionHoverColor: '#232323',
			selectOptionFocusColor: '#232323',
			selectOptionActiveColor: '#232323',
			selectOptionErrorColor: '#BC161D',
			selectOptionDisabledColor: '',

			selectOptionBgColor: '#FFFFFF',
			selectOptionHoverBgColor: '',
			selectOptionFocusBgColor: '#ECEFEC',
			selectOptionActiveBgColor: '',
			selectOptionErrorBgColor: 'rgb(250, 243, 240)',
			selectOptionDisabledBgColor: '',

			//! Radio
			radioBorderColor: '#D5D5D5',
			radioBorderActiveColor: '#161616',
			radioBgColor: '#FFFFFF',
			radioActiveBgColor: '#161616',

			//! Upload
			uploadBgColor: 'rgba(0, 0, 0, 0.02)',
			uploadBorderColor: '#d9d9d9',
		},
	},
};
